import { windowWidth, windowHeight } from "../layout";

function pageBannerBreadcrumb() {
    const breadcrumb = document.querySelector('.page-banner__breadcrumb');
    const breadcrumbDesktopWrapper = document.querySelector('.page-banner__breadcrumb-wrapper');
    const breadcrumbMobileWrapper = document.querySelector('.page-banner__image-wrapper');
    
    if (window.innerWidth < 576) {
        breadcrumbMobileWrapper.append(breadcrumb);
    } else {
        breadcrumbDesktopWrapper.append(breadcrumb);
    }
}

document.addEventListener("DOMContentLoaded", function () {
    pageBannerBreadcrumb();
})

window.addEventListener('resize', function(event) {
    pageBannerBreadcrumb();
}, true);